/**
 * @author Stefan
 * @filename request
 */

import axios, { AxiosRequestConfig } from "axios"

import { ENV } from "@/config"

const config = {
    timeout: 1000000,
    baseURL: ENV ? "https://reelpay-api.puttest.com" : "https://api.reelpay.com"
}

const service = axios.create(config)

service.interceptors.request.use(
    config => {
        let token = window.location.pathname.split("/")
        if (token[token.length - 1]) {
            config.headers!["X-Token"] = token[token.length - 1]
        }

        return config
    },
    error => {
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        if (response.data.code === 200) {
            return response.data.data
        }
        return Promise.reject(response.data.data)
    },
    error => {
        switch (error.response.status) {
            case 422:
                return Promise.reject(error.response.status)
        }
        return Promise.reject(error.response)
    }
)

export function get<T>(url: string, data?: any, config?: AxiosRequestConfig) {
    return service.get<any, T>(url, { params: data, ...config })
}

export function post<T>(url: string, data?: any, config?: AxiosRequestConfig) {
    return service.post<any, T>(url, data, config)
}

export default {
    get,
    post,
    service
}
